import React from 'react';
import io from 'socket.io-client';
import Environment from 'config/environment';
import { loadFromLocalStorage } from 'redux/utils/storage';
import { getSessionId } from 'utils/session';
import _ from 'lodash';

const chatConnectionUrl = `${Environment.SOCKET_BASE_URL}/chat`;

const socket = io(chatConnectionUrl, {
  reconnectionDelayMax: 10000,
  transports: ['websocket'],
  auth: (cb) =>
    cb({
      token: loadFromLocalStorage()?.AuthReducer?.token ?? '',
      sessionId: getSessionId(),
    }),
});

socket.on('connect', () => {
  console.log('Connected!');
});

// either by directly modifying the `auth` attribute
socket.on('connect_error', () => {
  console.log('Connect Error!');

  // socket.auth.token = "abcd";
  // socket.connect();
});

// socket.on('messageAdd', (data: any) => {
//   console.log('add message!!!!', data);
// });

export const reconnectToChat = async () => {
  socket.close();
  _.set(socket, 'auth', {
    token: loadFromLocalStorage()?.AuthReducer?.token ?? '',
    sessionId: getSessionId(),
  });

  socket.connect();
};

export default socket;
